import { render, staticRenderFns } from "./CampaignCleanup.vue?vue&type=template&id=624d8996&"
import script from "./CampaignCleanup.vue?vue&type=script&lang=js&"
export * from "./CampaignCleanup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports